export const OBTER_CONTRATOS_REQUEST = 'OBTER_CONTRATOS_REQUEST';
export const OBTER_CONTRATOS_SUCCESS = 'OBTER_CONTRATOS_SUCCESS';
export const SET_SIMULATION = 'SET_SIMULATION';
export const OBTER_DADOS_SOLICITACAO_REQUEST =
  'OBTER_DADOS_SOLICITACAO_REQUEST';
export const OBTER_DADOS_SOLICITACAO_SUCCESS =
  'OBTER_DADOS_SOLICITACAO_SUCCESS';
export const OBTER_LIMITE_EMPRESTIMO_REQUEST =
  'OBTER_LIMITE_EMPRESTIMO_REQUEST';
export const OBTER_LIMITE_EMPRESTIMO_SUCCESS =
  'OBTER_LIMITE_EMPRESTIMO_SUCCESS';
export const RESET_EMPRESTIMO = 'RESET_EMPRESTIMO';
